<template>
  <v-container>
    <AreasProgressLinear></AreasProgressLinear>
    <v-spacer></v-spacer>
    <GenericChecklist @complete="complete" @uncomplete="uncomplete" :headers="[{text:'completed', value:'completed'},{text:'area', value:'id'},{text:'type', value:'type'}]" :items="filtered" :itemKey="'id'" :groupBy="'type'"></GenericChecklist>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

import GenericChecklist from '@/components/GenericChecklist'
import AreasProgressLinear from "@/components/AreasProgressLinear";


export default {
  name: "Areas",
  components: { AreasProgressLinear, GenericChecklist },
  computed: {
    ...mapGetters("entities/areas",["filtered"])
  },
  methods: {
    ...mapActions("entities/areas", ["complete", "uncomplete"]),
  },
};
</script>
